export default __webpack_public_path__ + "static/media/timer.7f855ed1.svg";